import { createSlice } from '@reduxjs/toolkit';
import account from '../_mock/account';

const initialState = {
  id: '',
  displayName: '',
  role: '',
  email: '',
  photoURL: '',
  phoneNumber: '',
  username: '',
  password: '',
  language: 'uz',
};

export const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setUser: (state, { payload }) => {
      state.id = payload.id;
      state.displayName = payload.displayName;
      state.username = payload.username;
      state.role = payload.role;
      state.email = payload.email;
      state.photoURL = payload.photoURL;
      state.phoneNumber = payload.phoneNumber;
      state.password = payload.password;
    },
    setDisplayName: (state, { payload }) => {
      state.displayName = payload;
    },
    setEmail: (state, { payload }) => {
      state.email = payload;
    },
    setPhotoURL: (state, { payload }) => {
      state.photoURL = payload;
    },
    setUsername: (state, { payload }) => {
      state.username = payload;
    },
    setPassword: (state, { payload }) => {
      state.password = payload;
    },
    setLanguage: (state, { payload }) => {
      state.language = payload;
      localStorage.setItem('language', payload);
    },
  },
});

export const { setUser, setDisplayName, setUsername, setEmail, setPassword, setPhotoURL, setLanguage } =
  accountSlice.actions;

export default accountSlice.reducer;
